<!-- Create form state -->
<div *ngIf="!createdToken">
  <div class="dialog-header">
    <h2 mat-dialog-title class="mb-0">Generate API Token</h2>
    <button mat-icon-button (click)="onClose()" matTooltip="Close" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="pt-2">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Token Name</mat-label>
      <input matInput [(ngModel)]="name" maxlength="255" placeholder="e.g. Zapier integration" required>
      <mat-hint>Give the token a name that identifies where it will be used.</mat-hint>
    </mat-form-field>

    <div class="mt-3">
      <mat-slide-toggle [(ngModel)]="neverExpires">Never expires</mat-slide-toggle>
    </div>

    <mat-form-field appearance="outline" class="w-100 mt-3" *ngIf="!neverExpires">
      <mat-label>Expiry Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="expiresAt" [min]="minDate" [disabled]="neverExpires">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-hint>The token will stop working after this date.</mat-hint>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()" [disabled]="creating">Cancel</button>
    <button mat-raised-button color="primary" (click)="onCreate()" [disabled]="creating">Generate</button>
  </mat-dialog-actions>
</div>

<!-- One-time reveal state -->
<div *ngIf="createdToken">
  <div class="dialog-header">
    <h2 mat-dialog-title class="mb-0">Token Created</h2>
    <button mat-icon-button (click)="onClose()" matTooltip="Close" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="pt-2">
    <div class="alert alert-warning">
      <mat-icon class="align-middle mr-2">warning</mat-icon>
      Copy this token now. For your security, it cannot be shown again.
    </div>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Your API Token</mat-label>
      <input matInput [value]="createdToken.plaintext_token" readonly>
      <button mat-icon-button matSuffix ngxClipboard [cbContent]="createdToken.plaintext_token"
              (cbOnSuccess)="utils.showToast('Token copied to clipboard.')" matTooltip="Copy to clipboard">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onClose()">Done</button>
  </mat-dialog-actions>
</div>
